import api from './api';
import type { WineListRender } from '../types/venue';

/**
 * Anonymous, public wine list rendering. Hits the unauthenticated
 * /api/public/wine-list/:slug endpoint.
 *
 * The `api` axios client may attach a stale auth token from localStorage if
 * the device has ever been logged in to admin — that's harmless: the public
 * endpoint ignores authentication entirely.
 */
const publicWineListService = {
  getBySlug: async (slug: string): Promise<WineListRender> => {
    const response = await api.get(`/public/wine-list/${encodeURIComponent(slug)}`);
    return response.data;
  },
};

export default publicWineListService;
